import { WebPlugin } from '@capacitor/core';
export class SafeAreaWeb extends WebPlugin {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async enable(_options) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async disable(_options) {
        return;
    }
}
//# sourceMappingURL=web.js.map